import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import TextArea from "../../../../library/custom/textArea/TextArea";
import Buttons from "../../../../library/custom/button/Button";
import { getDaysRemaining, InactiveClient } from "../../../../utils/helper";
import { USER_ID } from "../../../../constant/constant";
import "./oshaToken.scss";

const OshaToken = (props) => {
  const { lastUpdatedOn, token } = props?.oshaTokenDetails?.data || {};
  const initialState = {
    description: "",
  };
  const [formValue, setFormValue] = useState(initialState);
  const [isDescriptionError, setIsDescriptionError] = useState(false);

  function mappedData() {
    let errors = false;
    if (formValue?.description?.trim() === "") {
      setIsDescriptionError(true);
      errors = true;
    }
    if (errors) {
      return false;
    }

    const data = {
      userId: parseInt(USER_ID()),
      token: formValue.description,
    };
    return data;
  }
  const submitData = () => {
    if (InactiveClient()) return;
    const data = mappedData();
    if (!data) {
      return;
    }
    props?.onSubmit(data);
  };

  useEffect(() => {
    if (
      props?.addOshaToken?.status === "SUCCESS" &&
      props?.addOshaToken?.isLoading === false
    ) {
      setFormValue({
        description: "",
      });
    }
  }, [props?.addOshaToken]);

  return (
    <>
      <Grid item lg={12} md={12} xs={12} mt={0} mb={3}>
        <FormControl fullWidth className="oshaPrevious">
          <FormLabels label="Previous Token" isRequired={true} />
          <p className="token">{token}</p>
          <p className="date">
            Token expires in: {getDaysRemaining(lastUpdatedOn)} days
          </p>
        </FormControl>
      </Grid>
      <Grid item lg={12} md={12} xs={12} mt={1}>
        <FormControl fullWidth>
          <FormLabels label="Token" isRequired={true} />
          <TextArea
            placeholder={"Enter Here"}
            value={formValue?.description}
            onChange={(e) =>
              setFormValue({
                ...formValue,
                description: e.target.value,
              })
            }
            isError={isDescriptionError}
            errorMsg={"Please add Token"}
          />
        </FormControl>
      </Grid>

      <Grid container mt={2}>
        <Grid item lg={4} xs={12} sm={5} md={5}>
          <Buttons
            varientContained={true}
            label={"Save"}
            onClick={submitData}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default OshaToken;
